//      
import {               } from 'css-box-model';
import { invariant } from '../../../invariant';
             
                        
              
          
             
             
                        
import { add } from '../../position';
import getCombinedItemDisplacement from '../../get-combined-item-displacement';
import { tryGetCombine } from '../../get-impact-location';

              
                     
                                 
                                    
                            
   

// Returns the client offset required to move an item from its
// original client position to its final resting position
export default ({ afterCritical, impact, draggables }      )           => {
  const combine           = tryGetCombine(impact);
  invariant(combine);

  const combineWith              = combine.draggableId;
  const center           = draggables[combineWith].page.borderBox.center;

  const displaceBy           = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical,
    combineWith,
    displacedBy: impact.displacedBy,
  });

  return add(center, displaceBy);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-center-from-impact/get-page-border-box-center/when-combining.js